<template>
  <div class="pay_list">
    <dl>
      <dt>订单编号：{{businessId}}</dt>
      <dd>
        <img v-if="params.faceUrl" :src="params.faceUrl" class="list_img" />
        <img v-if="!params.faceUrl || params.faceUrl==''" src="@/assets/images/class_img.jpg" class="list_img" />
        <h3>{{params.name}}</h3>
        <p class="price_a">金额 ¥<span>{{params.coursePriceList[0].price}}</span>元</p>
      </dd>
    </dl>
  </div>
</template>
<script>
export default {
  name: 'coursePayInfo',
  props: ['businessID', 'productID'],
  data () {
    return {
      productId: this.productID,
      businessId: this.businessID,
      params: {coursePriceList: [{}]},
      result: {}
    }
  },
  created () {
    this.getCourse(this.productId)
  },
  methods: {
    getCourse (id) {
      this.$api.getRestful(this.$global.courseApiPath, '/course/get/' + id, {}, r => {
        if (r.data) {
          this.params = r.data
          this.getBuyRecord(this.businessId)
        }
      })
    },
    getBuyRecord (businessId) {
      this.$api.post(this.$global.courseApiPath, '/course/buy/buys', {id: businessId, delFlag: '0'}, r => {
        if (r.data) {
          this.buyRecord = r.data[0]
          this.result = {
            money: this.buyRecord.price,
            subject: this.params.name
          }
          this.$emit('success', this.result)
        }
      })
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/page/modules/course/pay_info.vue